var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Section"},[_c('img',{attrs:{"id":_vm.name,"src":_vm.image,"alt":_vm.altText}}),_c('h2',[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }